module.exports = __webpack_public_path__ + "resources/img/bg_banner_support_v2.d60801288e62c8a3dff62a4f65a457b5.png";